<template>
  <main>
    <page-header-compact> Lista de Citologias </page-header-compact>
    <div class="container-fluid">
      <div class="card mt-2">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="form-label font-weight-bolder">Usuario</label>
                <input class="form-control form-control-sm" v-model="pagination.params.usuario" />
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="form-label font-weight-bolder">Fecha</label>
                <date-picker class="w-100" v-model="pagination.params.fecha" range valueType="format"
                  placeholder="Seleccione fechas"></date-picker>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="form-label font-weight-bolder">EPS</label>
                <v-select-eps v-model="pagination.params.id_eps"></v-select-eps>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="form-label font-weight-bolder">Tipo Tamizaje</label>
                <div class="d-flex align-items-center bg-light rounded-lg px-2">
                  <div class="custom-control custom-checkbox mr-3">
                    <input type="checkbox" class="custom-control-input" id="checkCitologia" value="CITOLOGIA"
                      v-model="pagination.params.filtro_tamizaje">
                    <label class="custom-control-label" for="checkCitologia">CITOLOGÍAS</label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="checkAdnVph" value="ADN/VPH"
                      v-model="pagination.params.filtro_tamizaje">
                    <label class="custom-control-label" for="checkAdnVph">ADN/VPH</label>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <label class="form-label font-weight-bolder">Profesional</label>
                <v-select-user v-model="pagination.params.id_user"></v-select-user>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label class="form-label font-weight-bolder">Sede</label>
                <auto-complete-sede v-model="sede"></auto-complete-sede>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="pt-4 d-flex">
                <button class="btn btn-primary mt-2 btn-sm mx-2" @click="getCitologias()">
                  <i class="fa fa-search fa-fw"></i> Buscar
                </button>
                <button class="btn btn-light mt-2 btn-sm" @click="resetFilters()">
                  <i class="fa fa-broom fa-fw"></i> Limpiar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card-body">
          <data-grid :data="pagination" @changePage="changePage($event)" @perPageChange="perPageChange($event)"
            @search="search($event)" :search-box="false">
            <template #grid>
              <div class="row ">
                <div v-for="(cit, i) in pagination.data" :key="`${i}_citologias`" class="col-12 mb-3">
                  <div class="citologia-card"
                    :class="cit.resultado === 'SI' ? 'citologia-card--done' : 'citologia-card--pending'">

                    <!-- Row 1: Metadata (Fecha, Tamizaje, Muestra, Estado) -->
                    <div class="row">
                      <div class="col-lg-4 col-md-12 col-sm-12 d-flex align-items-center" style="gap: 10px;">
                        <span class="font-weight-bold text-gray-600">
                          <i class="far fa-calendar-alt mr-1"></i>{{ cit.fecha | formatDate }}
                        </span>
                        <span class="badge badge-light text-gray-700 font-weight-bold badge-marketing">{{
                          cit.tipo_tamizaje }}</span>
                      </div>
                      <div class="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-end align-items-center"
                        style="gap: 16px;">
                        <span class="font-weight-bold text-gray-600">
                          Mtra: {{ cit.id }}
                        </span>
                        <span v-if="cit.id_resultado" class="text-gray-600 font-weight-bold">
                          Res: {{ cit.id_resultado }}
                        </span>
                        <span :class="mapAppointmentState(cit.resultado).badgeClass">
                          <i :class="mapAppointmentState(cit.resultado).badgeIcon" class="mr-1"></i>{{
                            mapAppointmentState(cit.resultado).badgeText }}
                        </span>
                      </div>
                    </div>

                    <!-- Row 2 & 3: Paciente, EPS y Acciones -->
                    <div class="row mt-1">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <h6 class="text-gray-900 mb-0">
                          <span class="">({{ cit.documento }})</span>
                          {{ cit.usuario }}
                        </h6>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-6 col-md-12 col-sm-12">
                        <i v-if="cit.eps" class="badge badge-light text-gray-700 font-weight-bold">
                          <i class="far fa-building mr-1"></i>{{ cit.eps }}
                        </i>
                      </div>
                      <div class="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-end">
                        <router-link v-if="cit.resultado === 'NO' && _can('resultados.create')" target="_blank"
                          :to="{ name: 'historias.citologia.resultado.create', params: { id: cit.id, type: cit.tipo_tamizaje } }"
                          class="btn btn-primary btn-xs">
                          <i class="fas fa-plus fa-fw mr-1"></i> Llenar Resultados
                        </router-link>
                        <template v-else>
                          <button title="Imprimir" class="btn btn-transparent-light" @click="printResults(cit.id)">
                            <i class="fa fa-print text-gray-600"></i>
                          </button>
                          <router-link :to="{ name: 'historias.citologia.resultado.edit', params: { id: cit.id } }"
                            title="Editar" class="btn btn-transparent-light">
                            <i class="fa fa-edit text-primary"></i>
                          </router-link>
                          <button v-if="cit.id_user_resultado === user.id" title="Eliminar"
                            class="btn btn-transparent-light" @click="deleteResultados(cit.id_resultado)">
                            <i class="fa fa-trash text-danger"></i>
                          </button>
                        </template>
                      </div>
                    </div>

                    <!-- Row 4: Footer (Profesional y Sede) -->
                    <div class="citologia-card__footer">
                      <span class="footer-item">
                        <i class="far fa-user mr-1 text-secondary"></i>
                        <span class="label">Profesional:</span> {{ cit.user }}
                      </span>
                      <span class="footer-item">
                        <i class="fas fa-map-marker-alt mr-1 text-secondary"></i>
                        <span class="label">Sede:</span> {{ cit.sede }}
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import PageHeaderCompact from "../../../components/layouts/content/page-header-compact";
import DataGrid from "../../../components/common/utilities/DataGrid/DataGrid";
import citologiaService from "../../../services/citologiaService";
import VSelectUser from "../../../components/common/vSelectUser";
import typeAppService from "../../../services/typeAppService";
import Toast from "@/components/common/utilities/toast";
import AutoCompleteSede from "../../../components/common/autocompletes/AutoCompleteSede";
import Swal from "sweetalert2";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VSelectEps from "@/components/common/VSelectEps";
export default {
  name: "citologia.vue",
  components: {
    VSelectUser,
    DataGrid,
    PageHeaderCompact,
    AutoCompleteSede,
    DatePicker, VSelectEps
  },
  async created() {
    this.getCitologias();
    const { data } = await typeAppService.index();
    this.hcAppLink = data.find((app) => app.name === "HISTORIA").domain;
  },
  data() {
    return {
      headers: ["No. Res.", "No. mtra.", "Tamizaje", "Usuario", "Sede", "Fecha", "Profesional", "Resultados", "Acciones"],
      pagination: {
        data: [],
        current_page: 1,
        page: 1,
        per_page: 5,
        search: "",
        total: "",
        params: {
          id_user: "",
          fecha: "",
          usuario: "",
          estado: "",
          id_sede: "",
          filtro_tamizaje: ["CITOLOGIA", "ADN/VPH"],
          id_eps: "",
        },
      },
      hcAppLink: "",
      sede: {}
    };
  },
  methods: {
    printResults(id) {
      window.open(citologiaService.print(id));
    },
    resetFilters() {
      this.pagination.params.id_user = "";
      this.pagination.params.usuario = "";
      this.pagination.params.fecha = "";
      this.pagination.params.estado = "";
      this.pagination.params.id_sede = "";
      this.pagination.params.id_eps = "";
      this.pagination.params.filtro_tamizaje = ["CITOLOGIA", "ADN/VPH"];
      this.sede = {};
      this.getCitologias();
    },
    mapAppointmentState(resultado) {
      if (resultado === "NO") {
        return {
          rowClass: "bg-danger-soft",
          badgeClass: "text-danger badge badge-marketing badge-light",
          badgeIcon: "fa fa-times-circle fa-fw",
          badgeText: "Sin registrar",
        };
      } else if (resultado === "SI") {
        return {
          rowClass: "bg-success-soft",
          badgeClass: "text-success badge badge-marketing badge-light",
          badgeIcon: "fa fa-check fa-fw",
          badgeText: "Registrados",
        };
      }
      [resultado];
    },
    async getCitologias() {
      try {
        this.LoaderSpinnerShow();
        const response = (
          await citologiaService.index(this.pagination.search, this.pagination)
        )?.data;
        this.pagination.data = response.data.map((citologia) => {
          return {
            id: citologia.id,
            id_usuario: citologia.historia.usuario.id,
            documento: citologia.historia.usuario.documento,
            usuario: citologia.historia.usuario.full_name || `${citologia.historia.usuario.nombre_1} ${citologia.historia.usuario.nombre_2} ${citologia.historia.usuario.apellido_1} ${citologia.historia.usuario.apellido_2}`,
            sede: `${citologia.historia.sede.NOMBRE_SEDE}`,
            user: citologia.historia.user.name,
            id_user: citologia.historia.id_user,
            fecha: citologia.fecha_lectura,
            resultado: citologia.resultado ? "SI" : "NO",
            id_resultado: citologia.resultado?.id || '',
            id_user_resultado: citologia.resultado?.id_user || '',
            tipo_tamizaje: citologia.tipo_tamizaje,
            eps: citologia.historia.eps.DESEPS
          };
        });
        this.pagination.current_page = response.current_page;
        this.pagination.total = response.total;
        this.LoaderSpinnerHide();
      } catch (e) {
        console.error(e);
        this.LoaderSpinnerHide();
        Toast.fire({
          icon: "error",
          title: "Ocurrio un error al procesar la solicitud",
        });
      }
    },
    changePage(page) {
      this.pagination.page = page;
      this.getCitologias();
    },
    perPageChange(per_page) {
      this.pagination.per_page = per_page;
      this.pagination.page = 1;
      this.getCitologias();
    },
    search(query) {
      this.pagination.search = query;
      this.pagination.page = 1;
      this.getCitologias();
    },
    async deleteResultados(id_resultado) {

      const result = await Swal.fire({
        title: "¿Quiere eliminar el resultado #" + id_resultado + "?",
        text: "Esta opción no es reversible",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No',
        icon: "question",
        showLoaderOnConfirm: false,
        preConfirm: async () => {
          try {
            this.LoaderSpinnerShow();
            await citologiaService.delete(id_resultado);
            this.LoaderSpinnerHide();
          } catch (e) {
            console.error(e);
            this.LoaderSpinnerHide();
            Swal.showValidationMessage('ha ocurrido un error al procesar la solicitud');
          }
        },
      });

      if (result.isConfirmed) {
        Toast.fire({
          icon: 'success',
          title: 'Datos eliminados con exito'
        });

        this.getCitologias();
      }
    },

  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    sede: function (newVal, oldVal) {
      if (newVal.ID !== oldVal.ID) {
        this.pagination.params.id_sede = newVal.ID;
      }
    }
  },
};
</script>

<style scoped>
/* Card Styling */
.citologia-card {
  background: #ffffff;
  border: 1px solid #e2e9f0;
  border-left: 4px solid transparent;
  border-radius: 10px;
  padding: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  gap: 2px;
}


.citologia-card--done {
  border-left-color: #28a745;
}

.citologia-card--pending {
  border-left-color: #dc3545;
}


/* Card Footer (Profesional y Sede) */
.citologia-card__footer {
  border-top: 1px dashed #e2e8f0;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #718096;
}

.footer-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.footer-item .label {
  font-weight: 600;
  color: #4a5568;
}

/* Match AutoCompleteSede input height with Bootstrap form-control-sm */
::v-deep .autocomplete-input {
  height: 35px !important;
  font-size: 13px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

</style>
